module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "fluid"
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_c('v-card', {
    staticClass: "text-xs-center"
  }, [_c('basic-toolbar', {
    attrs: {
      "title": "Avalicação de participação e relatório de atividades na ação pelo bolsista"
    }
  }), _vm._v(" "), _c('v-card-text', [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.formularioValido),
      callback: function($$v) {
        _vm.formularioValido = $$v
      },
      expression: "formularioValido"
    }
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "lg8": ""
    }
  }, [_c('br'), _c('br'), _vm._v("\n\n                Atendendo à Instrução Normativa No 01/2017-PROEX, ao final do seu período de atuação como\n                bolsista, o aluno deverá proceder à sua “AVALIAÇÃO DE PARTICIPAÇÃO E RELATÓRIO DE ATIVI-\n                DADES” na ação de extensão “NOME DA AÇÃO DE EXTENSAO”, referente ao período de XX/XX/XXXX\n                a XX/XX/XXXX, respondendo o seguinte questionário a seguir.\n                Obs.: Caso a atuação do bolsista seja finalizada antes do prazo previsto inicialmente, ele deverá realizar a\n                avaliação da mesma forma, mesmo que por um mês de atividade.\n\n                "), _c('br'), _c('br'), _c('br'), _c('br'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Nome da ação de extensão",
      "required": "",
      "rules": _vm.regrasBasicas,
      "max-height": "400"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs11": "",
      "sm8": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Nome do aluno",
      "required": "",
      "rules": _vm.regrasBasicas,
      "max-height": "400"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Matrícula",
      "required": "",
      "rules": _vm.regrasBasicas,
      "max-height": "20"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs11": "",
      "sm8": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Nome do orientador",
      "required": "",
      "rules": _vm.regrasBasicas,
      "max-height": "400"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Tipo de bolsa",
      "required": "",
      "rules": _vm.regrasBasicas,
      "max-height": "20"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs11": "",
      "sm4": ""
    }
  }, [_c('c-date-menu', {
    attrs: {
      "label": "Data inicial de atuação",
      "clearable": "",
      "required": "",
      "rules": _vm.regrasBasicas
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm4": ""
    }
  }, [_c('c-date-menu', {
    attrs: {
      "label": "Data final de atuação",
      "clearable": "",
      "required": "",
      "rules": _vm.regrasBasicas
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Carga horária",
      "type": "number",
      "required": "",
      "rules": _vm.chRules
    }
  })], 1)], 1), _vm._v(" "), _c('br'), _c('br'), _c('br'), _c('br'), _vm._v(" "), _c('c-selecionar-nota', {
    attrs: {
      "label": "Desenvolvimento do ponto de vista pessoal e acadêmico",
      "rules": _vm.regrasBasicas
    }
  }), _vm._v(" "), _c('c-selecionar-nota', {
    attrs: {
      "label": "Interação da formação acadêmica com a prática",
      "rules": _vm.regrasBasicas
    }
  }), _vm._v(" "), _c('c-selecionar-nota', {
    attrs: {
      "label": "Vivência prática da integração ensino, pesquisa e extensão",
      "rules": _vm.regrasBasicas
    }
  }), _vm._v(" "), _c('c-selecionar-nota', {
    attrs: {
      "label": "Contribuição com a melhoria da sociedade",
      "rules": _vm.regrasBasicas
    }
  }), _vm._v(" "), _c('c-selecionar-nota', {
    attrs: {
      "label": "Desenvolvimento de senso de cidadania",
      "rules": _vm.regrasBasicas
    }
  }), _vm._v(" "), _c('c-selecionar-nota', {
    attrs: {
      "label": "Desenvolvimento da autonomia",
      "rules": _vm.regrasBasicas
    }
  }), _vm._v(" "), _c('c-selecionar-nota', {
    attrs: {
      "label": "Orientação recebida da coordenação",
      "rules": _vm.regrasBasicas
    }
  }), _vm._v(" "), _c('c-selecionar-nota', {
    attrs: {
      "label": "Pontuação média obtida (ou avaliação qualitativa geral atribuída)",
      "rules": _vm.regrasBasicas
    }
  }), _vm._v(" "), _c('v-layout', [_c('label', {
    staticClass: "black--text",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_vm._v("\n                    Relatório de atividades desenvolvidas pelo bolsista na ação (descrição sucinta).\n                  ")])]), _vm._v(" "), _c('v-layout', [_c('v-textarea', {
    attrs: {
      "rows": 5,
      "multi-line": "",
      "counter": "500",
      "rules": _vm.couterRules,
      "required": "",
      "outlined": ""
    },
    model: {
      value: (_vm.avaliacao.relatorio),
      callback: function($$v) {
        _vm.$set(_vm.avaliacao, "relatorio", $$v)
      },
      expression: "avaliacao.relatorio"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": "",
      "disabled": !_vm.formularioValido
    },
    on: {
      "click": _vm.criarBolsa
    }
  }, [_vm._v("Salvar")])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4df0429f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/bolsas/avaliacao-bolsista.vue
// module id = 404
// module chunks = 0